import React from 'react';
import Img from 'gatsby-image';
import { StoreSectionLayout } from './styles';
import useStoreSectionData from './dataQuery';
import { playStoreUrl, appStoreUrl } from '../../../constants';
import { SharpImage } from '../../../interfaces/SharpImage';
import { SectionTitle } from '../../../styles/globalStyled';

interface StoreSectionProps {
  title: string;
  subtitle: string;
  imageApp: SharpImage;
  imagePerson: SharpImage;
  imagePlayStore: SharpImage;
  imageAppStore: SharpImage;
}
const StoreSectionComponent: React.FC = () => {
  const data: StoreSectionProps = useStoreSectionData();

  return (
    <StoreSectionLayout>
      <section className="section-store section--gradient">
        <div className="column column-app is-12">
          <div className="column app-row is-8">
            <Img className="image-app" fluid={data.imageApp.childImageSharp.fluid} alt="app" />
            <div className="description-row">
              <h2>{data.title}</h2>
              <p>{data.subtitle}</p>
              <div className="app-icons">
                <a href={playStoreUrl} rel="noopener noreferrer" target="_blank">
                  <Img fixed={data.imagePlayStore.childImageSharp.fixed} alt="play-store" />
                </a>
                <a href={appStoreUrl} rel="noopener noreferrer" target="_blank">
                  <Img fixed={data.imageAppStore.childImageSharp.fixed} alt="app-store" />
                </a>
              </div>
            </div>
          </div>
          <div className="column user-row is-4">
            <Img className="image-app-user" fixed={data.imagePerson.childImageSharp.fixed} alt="user-app" />
          </div>
        </div>
      </section>
    </StoreSectionLayout>
  );
};

export default StoreSectionComponent;
